import { useEffect } from "react";
import { PageControl, KIND } from "baseui/page-control";
import { useNavigate } from 'react-router-dom';
import { Analytics,Gtag } from '../../compornents/Analytics';
import React from 'react';
import { BAG_FIRST } from '../../bagFirst';

// サービスの流れ STEP.2/4（bag-first改定 2026-09-01）。
// 改定前は「バッグを依頼→受け取る」の2枚だったが、新動線では
// 「バッグが届く → 入れる → 自分で集荷を依頼する → 届く」の4工程になる。
// 特にSTEP.1で「最初の配達はバッグであって、依頼品はまだ渡せない」ことを
// 注文前から刷り込んでおくのが、この改定で最も重要な役割。
export const RegisterStep2 = () => {
  const navigate = useNavigate();

  const next = () => {
    navigate(BAG_FIRST ? '/register/step3' : '/register/menu');
  }

  useEffect(() => {
    Gtag('view_register_step2');
  }, []);

  return (
    <div>
      <div>
        <Analytics title="Step2" />
        <div className="Register">
          <div className="App-step1">
            <div className="App-h1 pt-4">{"STEP.2"}</div>
            <img src="/img/step2.png" alt={BAG_FIRST ? "専用バッグに入れる" : "step2"} className="App-img" />
            {BAG_FIRST ? (
              <>
                <div className="App-title-sm">依頼品をバッグに入れる</div>
                <div className="App-comment">{"バッグが届いたら、クリーニングしたい衣類を\n3点まで専用バッグに入れてください。\n※Yシャツは2枚で1点カウント"}</div>
              </>
            ) : (
              <>
                <div className="App-title-sm">Uber Eatsの配達パートナー<br />から専用バッグを受け取る</div>
                <div className="App-comment">ご自宅へUber Eatsの配達パートナーが<br />専用バッグをお届けに参ります</div>
              </>
            )}
            <div className="App-h3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <PageControl
                  currentPage={2}
                  numPages={BAG_FIRST ? 4 : 2}
                  kind={KIND.default}
                  aria-label="label"
                />
              </div>
              <button className="button-next-w" onClick={next}>{BAG_FIRST ? "次へ" : "次へ"}</button>
              <div><img src="../img/Direct_delivered with_Uber Eats_horiz_pill_green_en_1@2x.png" className="ud_img" alt="ud logo" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
